import ApiInstance from './intercepter';
import API from '../config/api';

export const getSuperDirectorCamps = () => ApiInstance.get(API.GET_ALL_CAMPS_FOR_SUPER_DIRECTOR);

export const updateCampCodeService = params => ApiInstance.post(API.UPDATE_CAMP_CODE, params);

export const getDirectorsByCampCodeService = campCode => ApiInstance.get(API.GET_DIRECTORS_BY_CAMP_CODE + `?campCode=${campCode}`);

export const getDirectorInboxService = params => ApiInstance.get(API.GET_DIRECTOR_INBOX + params);

export const getDirectorChatHistoryService = params => ApiInstance.get(API.DIRECTOR_CHAT_HISTORY + params);
